import { QueryClient } from '@tanstack/react-query'

import { TrackingFnType } from '@hooks/useTracking'
import { OnShowOfferParams } from '@components/Piano/types'
import { getTrackingTemplateParams } from '@components/Piano/utils'

import {
  RecommendationsExtraDataTrackingType,
  TemplatesExtraDataTrackingType,
} from './types'

const trackingRecommendationsClick: TrackingFnType<
  RecommendationsExtraDataTrackingType
> = ({ extraData: { labelOrArticleId } }) => {
  return {
    event: 'element_click',
    element: 'blickplus_highlights_widget',
    element_label: labelOrArticleId,
  }
}

const trackingOffersImpression: (
  queryClient: QueryClient
) => TrackingFnType<TemplatesExtraDataTrackingType> =
  (queryClient) =>
  ({ extraData: { trackingId } }) => {
    const pianoTemplateParamsArray = queryClient.getQueryData<
      OnShowOfferParams[]
    >(['pianoTemplateParams'])

    // As there are multiple templates on the offer page, we need to find the right parameters
    // for tracking. We are using the trackingId set by Piano in the template to be able to
    // re-identify the templates for the impression tracking
    const pianoTemplateParams = pianoTemplateParamsArray?.find(
      (el) => el.trackingId === trackingId
    )

    const pianoTrackingTemplateNameParams = getTrackingTemplateParams(
      pianoTemplateParams?.experienceActionId
    )

    return {
      event: 'piano_show',
      piano_offer_id: pianoTemplateParams?.offerId || '',
      piano_template_id: pianoTemplateParams?.templateId || 'MAIN',
      piano_template_variant_id:
        pianoTemplateParams?.templateVariantId || 'MAIN',
      piano_experience_id: pianoTemplateParams?.experienceId || '',
      ...pianoTrackingTemplateNameParams,
    }
  }

export { trackingRecommendationsClick, trackingOffersImpression }
